import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/shared/services/http.service';

@Injectable({
  providedIn: 'root'
})
export class CompaniesService {

  constructor(
      private httpService: HttpService
  ) { }

  public getCompanyList = (): Promise<any> => this.httpService.get(`api/clients/list`).toPromise();

}
